import { gql, useQuery } from '@apollo/client';
import Projects from '../components/layout/work/projects';
import WorkText from '../components/layout/work/text';

export default function Work() {

    return (
        <>
            <section className='bg-purple-dark text-white-text pb-[10vh] min-h-[100vh]' >
                <span id="work" className='md:tab'>&nbsp;</span> 
                <WorkText />
                <article className='w-screen overflow-hidden'> 
                    <Projects />
                </article>
            </section>
        </>
        
    )
}